module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC1",
    attrs: {
      "id": "ded_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Dedication#ded01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC1"
  }), _vm._v(" "), _c('p', {
    staticClass: "x2TOC11",
    attrs: {
      "id": "int_01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062131829_Introduction#int01"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC1",
    attrs: {
      "id": "par_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062131829_Part_1#par1"
    }
  }, [_vm._v("PART ONE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blonde Pride")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_1#cha1"
    }
  }, [_vm._v("Chapter 1 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Know Thyself")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_2#cha2"
    }
  }, [_vm._v("Chapter 2 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don’t Be Afraid to Run in Heels")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_3#cha3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Crank Up the Pro-Blonde Anthems")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_4#cha4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don’t Date a Guy or Gal Who Is as Hair-Obsessed as You Are")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_5#cha5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Have a Blonde Mentor")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC1",
    attrs: {
      "id": "par_2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Part_2#par2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blonde Maintenance")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_6#cha6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natural Blondes Must Wear Sunscreen")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_7#cha7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Know How to Work the Weave")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_8#cha8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don’t Try This at Home: A Cautionary Tale")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_9#cha9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Heed True Blonde Confessions")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_10#cha10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spend Some Time on the Dark Side")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC1",
    attrs: {
      "id": "par_3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Part_3#par3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blonde Behavior")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_11#cha11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Keep It Classy")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_12#cha12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Channel Blonde Wisdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_13#cha13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Be Mindful of the Attention that Blonde Attracts")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_14#cha14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Be Capable")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_15#cha15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beware of Blond Bullies and Date Outside Your Color Group")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC1",
    attrs: {
      "id": "par_4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Part_4#par4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FOUR: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blonde Friendship")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_16#cha16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Have a Blondetourage")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_17#cha17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Expect Blonde-vs.-Brunette Tension")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC",
    attrs: {
      "id": "cha_18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Chapter_18#cha18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18 - RULE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Befriend Brunettes (and Others)")])])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC11",
    attrs: {
      "id": "faq_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_FAQs_with_Selena#faq01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAQs with Selena")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC11",
    attrs: {
      "id": "con_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Conclusion#con01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC11",
    attrs: {
      "id": "ack_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Acknowledgments#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC1"
  }), _vm._v(" "), _c('p', {
    staticClass: "x2TOC11",
    attrs: {
      "id": "ata_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC11",
    attrs: {
      "id": "cre_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Credits#cre01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC11",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062131829_Copyright#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC11",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b18c4d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062131829_Contents.vue
// module id = 66
// module chunks = 0